module.exports = __webpack_public_path__ + "img/Head_arrow.436adea8.svg";